import { useState, useEffect } from 'react';
import { client } from '../lib/sanity';

export const useContactPage = () => {
    const [contactData, setContactData] = useState(null);
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchContactData = async () => {
            try {
                const query = `*[_type == "contactUs"][0] {
          title,
          address {
            street,
            city,
            province,
            postalCode,
            country
          },
          contactInfo {
            phone,
            email
          },
          mapEmbed
        }`;

                const data = await client.fetch(query);
                setContactData(data);
                setIsLoading(false);
            } catch (err) {
                setError(err);
                setIsLoading(false);
            }
        };

        fetchContactData();
    }, []);

    return { contactData, isLoading, error };
}; 